<template>
  <div class="main">
    <div class="top">
      <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717605270411135.png" />
    </div>
    <div class="card">
      <div class="card-box">
        <div class="stu-name">{{ userInfo.realname }}</div>
        <div class="stu-school">{{ userInfo.school }}</div>
        <div class="stu-grade">入学{{ userInfo.join_year }}级</div>
        <div class="stu-record">
          <router-link to="/shaonianjingxiao/record">积分记录</router-link>
        </div>
        <div class="study-score"><span class="score">{{ userInfo.learn_jifen }}</span>分</div>
        <div class="active-score"><span class="score">{{ userInfo.active_jifen }}</span>分</div>
      </div>
    </div>
    <div class="baoming">
      <img src="https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718314808407484.png" @click="goToSign" />
    </div>
    <div class="bg">
      <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717627586908578.png" />
    </div>
    <div class="container">
      <div class="xuetang">
        <div class="top-line">
          <div class="title">
            <div class="title-decorate"></div>
            <div class="title-content">阿狮学堂</div>
          </div>
          <div class="more"><router-link to="videos">更多&gt;</router-link></div>
        </div>
        <div class="xuetang-video-list">
          <div class="xuetang-video" v-for="item in videos" :key="item.id">
            <a @click="classRedirect(item)">
              <div class="xuetang-video-screen">
                <img :src="item.cover" />
              </div>
              <div class="video-label"><img :src="item.hasWatched ? 'https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710203051753.png': 'https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710204271674.png'" /></div>
              <div class="xuetang-video-box">
                <div>
                  <div class="xuetang-video-title">{{item.title}}</div>
                  <div class="xuetang-video-content">{{ item.remark }}</div>
                </div>
                <div class="xuetang-video-play" v-if="item.type == 1">
                  <img src="https://i.tmuyun.com/webpic/W0202407/W020240719/W020240719462487967845.png" />
                </div>
              </div>
            </a>
          </div>
          
        </div>
      </div>
      <div class="fengcai">
        <div class="top-line">
          <div class="title">
            <div class="title-decorate"></div>
            <div class="title-content">少警风采</div>
          </div>
          <div class="more"><a href="https://app.tmuyun.com/webDetails/sonPage?id=10113619&tenantId=3&groupId=177255">更多&gt;</a></div>
        </div>
        <div class="fengcai-video-list">

          <div class="fengcai-video" v-for="item in atticles" :key="item.id">
            <a :href="item.url">
              <div class="fengcai-video-cover"><img :src="item.cover" /></div>
              <div class="fengcai-video-right">
                <div class="fengcai-video-title">{{item.title}}</div>
                <div class="fengcai-video-content">{{ item.mark }}</div>
              </div>
            </a>
          </div>

        </div>
      </div>
      <div class="duihuan">
        <div class="title">
          <div class="title-decorate"></div>
          <div class="title-content">积分兑换</div>
        </div>
        <div class="message-box">
          <van-icon name="https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718508034903731.png" />
          <div class="message">积分兑换即将开启，敬请期待</div>
        </div>
        <div class="gift-box">
          <div class="gift">
            <div class="gift-title">手提袋</div>
            <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717630648718013.png" />
            <div class="gift-score"><span class="score2">??</span>积分</div>
            <div class="gift-exchange" @click="exchange">立即兑换</div>
          </div>
          <div class="gift">
            <div class="gift-title">鼠标垫</div>
            <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717630653280638.png" />
            <div class="gift-score"><span class="score2">??</span>积分</div>
            <div class="gift-exchange" @click="exchange">立即兑换</div>
          </div>
          <div class="gift">
            <div class="gift-title">警车模型</div>
            <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717630652040976.png" />
            <div class="gift-score"><span class="score2">??</span>积分</div>
            <div class="gift-exchange" @click="exchange">立即兑换</div>
          </div>
          <div class="gift">
            <div class="gift-title">阿狮警长公仔1.0版</div>
            <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717630649935426.png" />
            <div class="gift-score"><span class="score2">??</span>积分</div>
            <div class="gift-exchange" @click="exchange">立即兑换</div>
          </div>
          <div class="gift">
            <div class="gift-title">阿狮警长公仔2.0版</div>
            <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717630650996634.png" />
            <div class="gift-score"><span class="score2">??</span>积分</div>
            <div class="gift-exchange" @click="exchange">立即兑换</div>
          </div>
          <div class="gift">
            <div class="gift-title">手提袋</div>
            <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717630653280638.png" />
            <div class="gift-score"><span class="score2">??</span>积分</div>
            <div class="gift-exchange" @click="exchange">立即兑换</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <img src="https://i.tmuyun.com/webpic/W0202407/W020240717/W020240717612782567500.png" />
    </div>
  </div>
</template>

<script>
import { getUserInfo, hasLogin, saveFirstLogin, getVideoList, getArticleList, viewArticle } from '@/api/snjx'
import { Dialog, Toast } from 'vant'
export default {
  data(){
    return {
      themeId: 1,
      userInfo: {},
      videos: [],
      atticles: []
    }
  },
  mounted() {
    let params = { theme_id: this.themeId }
    getUserInfo(params).then((res) => {
      if (res.code == 1) {
        if (res.data) {
          this.userInfo = res.data
          // 判断当天是否第一次登录
          hasLogin(params).then((re) => {
            if(re.code == 1){
              if(re.data === false){
                saveFirstLogin(params).then((r) => {
                  if(r.code == 1){
                    this.userInfo.learn_jifen = parseInt(this.userInfo.learn_jifen) + r.data
                    Toast.success(r.msg)
                  }else{
                    Toast.fail(r.msg)
                  }
                })
              }
            } else {
              Toast.fail(res.msg)
            }
          })

          // 获得文章列表
          getArticleList({theme_id: this.themeId, limit: 3}).then((re) => {
            if(re.code == 1){
              this.atticles = re.data
            }else{
              Toast.fail(re.msg)
            }
          })

          // 获得视频列表
          getVideoList({theme_id: this.themeId, limit: 2}).then((re) => {
            if(re.code == 1){
              this.videos = re.data
            }else{
              Toast.fail(re.msg)
            }
          })
        } else {
          Toast({
            type: 'fail',
            message: '请先注册',
            onClose: () => {
              this.$router.push({ name: 'snjx_register' })
            }
          })
        }
      } else {
        Toast.fail(res.msg);
      }
    })
  },
  methods: {
    classRedirect(item){
      if(item.type == 1){
        this.$router.push({name: 'snjx_video', params: {id: item.id}})
      }else{
        if(item.hasWatched == 1){
          window.location.href = item.url
        }else{
          const toast = Toast.loading('正在跳转')
          
          viewArticle({theme_id: this.themeId, article_id: item.id, type: item.type}).then((res) => {
            if(res.code == 1){
              item.hasWatched = 1
              Toast.clear()
              window.location.href = item.url
            }else{
              Toast.fail(res.msg)
            }
          })
        }
      }
      // :to="{name: 'snjx_video', params: {id: item.id}}"
    },
    goToSign(){
      if(this.userInfo.learn_jifen >= 50){
        window.location.href = 'https://wenling.y-h5.iyunxh.com/module-signup/home/home?hide_back=1&id=1864'
      }else{
        Dialog({message: '学习积分达到50分才可以报名'})
      }
    },
    exchange() {
      //
      Toast.fail('积分兑换暂未开启，敬请期待')
    },
  }
}
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .main {
    position: relative;
    height: 2450px;
    background:rgb(236,248,254);
  }

  .top {
    position: absolute;
    z-index: 1;
    top: 0;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .card {
    position: absolute;
    z-index: 2;
    top: 235px;
    width: 100%;

    .card-box {
      position: relative;
      margin: 0 auto;
      width: 375px;
      height: 250px;
      background: url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718570131167670.png') no-repeat;
      background-size: 100%;

      .stu-name {
        position: absolute;
        top: 30px;
        left: 40px;
        font-size: 23px;
        font-weight: bold;
        color: #000000;
      }

      .stu-school{
        position: absolute;
        top: 76px;
        left: 40px;
        padding: 0 0 0 30px;
        width:162px;
        height:22px;
        line-height: 22px;
        background:url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710396779364.png');
        background-size: 100%;
        font-size:12px;
        color:#000000;
      }

      .stu-grade{
        position: absolute;
        top: 106px;
        left: 40px;
        padding: 0 0 0 30px;
        width:162px;
        height:22px;
        line-height:22px;
        background:url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718710396538542.png');
        background-size: 100%;
        font-size:12px;
        color:#000000;
      }

      .stu-record{
        position:absolute;
        top:110px;
        right:30px;
        width:100px;
        height: 30px;
        line-height: 30px;
        border-radius: 16px;
        background:#5492EC;
        text-align:center;
        font-size:14px;
        font-weight: bold;
        a{
          color:#FFFFFF;
        }
      }

      .study-score{
        position: absolute;
        left: 76px;
        bottom: 76px;
      }
      .active-score{
        position: absolute;
        right: 76px;
        bottom: 76px;
      }
      .score{
        font-size:25px;
        font-weight: bold;
      }
    }
  }

  .baoming {
    position: absolute;
    z-index: 2;
    top: 480px;
    width: 100%;
    text-align: center;

    img {
      width: 350px;
    }
  }

  .bg {
    position: absolute;
    z-index: 1;
    top: 730px;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .container {
    position: absolute;
    z-index: 2;
    top: 620px;
    width: 100%;
  }

  .xuetang,
  .fengcai,
  .duihuan {
    width: 350px;
    margin: 30px auto 0 auto;
  }

  .top-line {
    display: flex;
    justify-content: space-between;
  }

  .title {
    display: flex;

    .title-decorate {
      width: 6px;
      background: #136AE8;
      border-radius: 5px;
    }

    .title-content {
      margin: 0 0 0 8px;
      font-size: 20px;
      color: #000000;
      font-weight: bold;
    }
  }

  .more {
    a {
      color: #818181;
    }
    font-size: 15px;
  }

  .xuetang-video-list{
    margin: 20px 0;
    .xuetang-video{
      width: 350px;
      height: 248px;
      margin: 10px 0;
      background:url('https://i.tmuyun.com/webpic/W0202407/W020240719/W020240719400638396180.png');
      background-size: 100%;

      .xuetang-video-screen{
        position: relative;
        top: 30px;
        left: 20px;
        width: 310px;
        height: 165px;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }
      }

      .video-label{
        position: relative;
        left: 270px;
        top: -110px;
        width: 80px;
        img{width:100%;}
      }

      .xuetang-video-box{
        // position: relative;
        // top: 8px;
        // left: 20px;
        // width: 310px;
        width: 88%;
        margin: auto;
        margin-top: 5px;
        display:flex;
        justify-content: space-between;
        .xuetang-video-title{
          color: #000;
          font-size: 14px;
        }
        .xuetang-video-content{
          margin-top: 3px;
          font-size: 12px;
          color:#959595;
        }
      }
      .xuetang-video-play{
        width: 30px;

        img{width:100%;}
      }
    }
  }

  .fengcai-video-list{
    .fengcai-video{
      margin: 10px 0;
      padding: 10px;
      border-radius: 10px;
      background:#fff;
      box-shadow: 0.67px 0.74px 8px #A3C1EB4D;
      a{
        display:flex;
        justify-content:space-between;
        .fengcai-video-cover{
          width:165px;
          height:95px;
          background:#136AE8;
          border-radius: 10px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .fengcai-video-right{
        width: 145px;
        .fengcai-video-title{
          color: #000;
          font-size: 16px;
        }
        .fengcai-video-content{
          margin: 20px 0 0 0;
          font-size:16px;
          color:#959595;
        }
      }
    }
  }

  .message-box {
    margin: 16px 0;
    padding: 10px 16px;
    background: rgba(55, 136, 235, 0.33);
    border-radius: 20px;
    display: flex;
  }

  .message {
    border-left: 1px solid #FFFFFF;
    font-size: 14px;
    color: #000000;
    margin: 0 0 0 8px;
    padding: 0 0 0 8px;
  }

  .gift-box {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-around;
  }

  .gift {
    margin: 6px 0;
    width: 165px;
    height: 190px;
    background: url('https://i.tmuyun.com/webpic/W0202407/W020240718/W020240718621423124431.png');
    background-size: 100%;

    .gift-title {
      margin-top: 8px;
      width: 100%;
      text-align:center;
      font-size:11px;
      color:#FFFFFF;
    }
    img {
      margin-top: -22px;
      width: 100%;
    }
    .gift-score{
      margin: -47px 0 0 24px;
      font-size: 12px;
    }
    .score2{
      font-size:20px;
      font-weight: bold;
    }
    .gift-exchange{
      margin: -18px 0 0 98px;
      bottom:26px;
      font-size: 9px;
      color:#fff;
    }
  }

  .bottom {
    position: absolute;
    z-index: 1;
    bottom: 0;
    width: 100%;

    img {
      width: 100%;
    }
  }
</style>